export enum FileValidationErrorType {
	MaxSizeError,
	ExtensionError,
	None
}
